import { Component } from 'react';

export class PendingStatusSVG extends Component<{
    className?: string;
    'data-testid'?: string;
}> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                data-testid={this.props['data-testid']}
                fill="none"
                width="20px"
                height="20px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
            >
                <g clipPath="url(#clip0)">
                    <circle
                        cx="10"
                        cy="10"
                        r="7.5"
                        fill="#4D809E"
                        stroke="#4D809E"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7 10a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z"
                        fill="#fff"
                    />
                </g>
                <defs>
                    <clipPath id="clip0">
                        <path d="M0 0h20v20H0V0z" fill="#fff" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}
